export const API_BASE_URL = "/api/v1";
export const API_BASE_URL_AUTH = "/api/v1/auth";

export const API_URL_LOGIN = `${API_BASE_URL}/auth/login`;
export const API_URL_PROFILE = `${API_BASE_URL}/auth/profile`;
export const API_URL_USERS = `${API_BASE_URL}/users`;
export const API_URL_SELLERS = `${API_BASE_URL}/sellers`;
export const API_URL_STORES = `${API_BASE_URL}/stores`;
export const API_URL_QUOTES = `${API_BASE_URL}/quotes`;
// Catálogo (PIM). El listado de publicados sale del índice main, así que devuelve la
// respuesta de Algolia (`hits`/`nbHits`) y no el `{data,total}` del dataProvider; los
// borradores y pendientes salen por SQL. Son endpoints distintos a propósito: paginar la
// unión de dos fuentes con capacidades de filtro distintas obliga a materializar las dos.
export const API_URL_PIM_PRODUCTS = `${API_BASE_URL}/pim/products`;
export const API_URL_PIM_DRAFTS = `${API_BASE_URL}/pim/drafts`;
export const API_URL_PIM_ATTRIBUTE_SETS = `${API_BASE_URL}/pim/attribute-sets`;
export const API_URL_PIM_ATTRIBUTES = `${API_BASE_URL}/pim/attributes`;
export const API_URL_PIM_IMPORTS = `${API_BASE_URL}/pim/imports`;
export const API_URL_PIM_BULK = `${API_BASE_URL}/pim/products/bulk`;
export const API_URL_PIM_CATALOG_ADMINS = `${API_BASE_URL}/pim/catalog/admins`;
export const API_URL_ORDERS = `${API_BASE_URL}/orders`;
export const API_URL_CONTACTS = `${API_BASE_URL}/contacts`;
export const API_URL_CONTACTS_SEARCH = `${API_BASE_URL}/contacts/search`;
export const API_URL_CONTACT_GROUPS = `${API_BASE_URL}/contact-groups`;
export const API_URL_CONTACTS_IMPORT = `${API_BASE_URL}/contacts/import`;
export const API_URL_CONTACTS_IMPORT_CONFIG = `${API_BASE_URL}/contacts/import/configuration`;
export const API_URL_CONTACTS_IMPORT_ITEMS = `${API_BASE_URL}/contacts/import/items`;
export const API_URL_CONTACTS_IMPORT_FILE = `${API_BASE_URL}/contacts/import/file`;
export const API_URL_ADDRESSES = `${API_BASE_URL}/users-address`;
export const API_URL_USER_ADDRESSES_V1 = `${API_BASE_URL}/addresses`;

export const API_URL_LINKED_IMPORT_CONFIG = `${API_BASE_URL}/sellers/linkedproducts/import/configuration`;
export const API_URL_LINKED_IMPORT = `${API_BASE_URL}/sellers/linkedproducts/import`;
export const API_URL_LINKED_IMPORT_ITEMS = `${API_BASE_URL}/sellers/linkedproducts/import/items`;
export const API_URL_LINKED_IMPORT_FILE = `${API_BASE_URL}/sellers/linkedproducts/import/file`;
export const API_URL_LINKED_SEARCH = `${API_BASE_URL}/sellers/linkedproducts`;
export const API_URL_LINKED_INTEGRATION = `${API_BASE_URL}/sellers/linkedproducts/integration`;

export const API_URL_PERMISSIONS = `${API_BASE_URL}/permissions`;
export const API_URL_PERMISSIONS_PARTICIPATION = `${API_BASE_URL}/permissions/participation`;
export const API_URL_STRUCTURE = `${API_BASE_URL}/permissions/seller/structure`;

export const API_URL_PERMISSIONS_STORES = `${API_BASE_URL}/permissions/store`;
export const API_URL_STRUCTURE_STORES = `${API_BASE_URL}/permissions/store/structure`;

export const LINK_MARKETPLACE = "marketplace/quote/create/";
export const LINK_MARKETPLACE_HASH = "marketplace/quote/view/uid/";

export const API_URL_GET_TEMPLATE = `${API_BASE_URL}/email-templates/template`;
export const API_URL_POST_TEMPLATE = `${API_BASE_URL}/email-templates/store`;
export const API_URL_GET_TEMPLATE_VARIABLES = `${API_BASE_URL}/email-templates/variables`;

export const API_URL_GET_RECEIPT = `${API_BASE_URL}/orders/payments/receipts`;
export const API_URL_GET_INVOICE = `${API_BASE_URL}/orders/payments/invoices`;

export const API_URL_GET_CREDIT_MEMO = `${API_BASE_URL}/orders/credit-memos`;

export const API_URL_PAYMENTS = `${API_BASE_URL}/orders/payments`;

export const API_URL_SHIPMENT = `${API_BASE_URL}/orders/shipments`;

export const API_URL_STORE_LINKED_SELLER = `${API_BASE_URL}/store-linked-seller`;

export const API_AUTOMATION = `${API_BASE_URL}/automation/embed-token`;

export const VITE_GOOGLE_MAPS_API_KEY =
  import.meta.env.MODE === "development"
    ? "AIzaSyDWDPqOphpQnfuHvIJ8HaPKUruaeWmzpwk"
    : "AIzaSyCUuy1I19eOHtvadQF_hlwJDRm1ObjHlJY";
